import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import axiosInstance from "../config/axiosInstance";
import { API } from "../config/apiConfig";
import { isTokenValid } from "../utils/auth";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  const refreshUser = async () => {
    if (!token || !isTokenValid(token)) {
      setUser(null);
      setLoading(false);
      return;
    }

    try {
      const { data } = await axiosInstance.get("/auth/me");
      setUser(data.user || null);
      localStorage.setItem("user", JSON.stringify(data.user || null));
    } catch (error) {
      setUser(null);
      localStorage.removeItem("user");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshUser();
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(API.AUTH.LOGIN, { email, password });
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password) => {
    const { data } = await axios.post(API.AUTH.REGISTER, {
      email,
      password,
      role: "ADVERTISER",
    });
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setToken(null);
    setUser(null);
  };

  const value = useMemo(
    () => ({
      token,
      user,
      loading,
      login,
      register,
      logout,
      refreshUser,
    }),
    [token, user, loading]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
